import React from "react";

const CookieData = () => {
  return (
    <div className="modal_body">
      <h3 className="text_center">WESTREAM COOKIE POLICY</h3>
      <p>
        <strong>Last updated: June 01, 2022</strong>
        <br />
        This Cookies Policy explains what Cookies are and how We use them. You
        should read this policy so You can understand what type of cookies We
        use, or the information We collect using Cookies and how that
        information is used. This Cookies Policy has been created with the help
        of the Cookies Policy Generator.
        <br />
        Cookies do not typically contain any information that personally
        identifies a user, but personal information that we store about You may
        be linked to the information stored in and obtained from Cookies. For
        further information on how We use, store and keep your personal data
        secure, see our Privacy Policy.
        <br />
        We do not store sensitive personal information, such as mailing
        addresses, account passwords, etc. in the Cookies We use.
      </p>
      <h4>
        <u>Interpretation and Definitions</u>
      </h4>
      <h5>Interpretation</h5>
      <p>
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions. The following definitions shall
        have the same meaning regardless of whether they appear in singular or
        in plural.
      </p>
      <h5>Definitions</h5>
      <p>For the purposes of this Cookies Policy</p>
      <ul>
        <li>
          {" "}
          <b>Company </b> (referred to as either "the Company", "We", "Us" or
          "Our" in this Cookies Policy) refers to WeStream.
        </li>
        <li>
          <b>Cookies </b> means small files that are placed on Your computer,
          mobile device or any other device by a website, containing details of
          your browsing history on that website among its many uses.
        </li>
        <li>
          <b>Website </b> refers to WeStream, accessible from{" "}
          <a href="https://www.westream.app" target="_blank">
            https://www.westream.app
          </a>
        </li>
        <li>
          <b>You </b> means the individual accessing or using the Website, or a
          company, or any legal entity on behalf of which such individual is
          accessing or using the Website, as applicable.
        </li>
      </ul>
      <h4>
        <u>The use of the Cookies</u>
      </h4>
      <h5>Type of Cookies We Use</h5>
      <p>
        Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies
        remain on your personal computer or mobile device when You go offline,
        while Session Cookies are deleted as soon as You close your web browser.
      </p>
      <p>
        We use both session and persistent Cookies for the purposes set out
        below:
      </p>
      <p style={{ paddingLeft: "10px" }}>
        <b>Necessary / Essential Cookies</b>
        <br />
        Type: Session Cookies <br />
        Administered by: Us <br />
        Purpose: These Cookies are essential to provide You with services
        available through the Website and to enable You to use some of its
        features. They help to authenticate users and prevent fraudulent use of
        user accounts. Without these Cookies, the services that You have asked
        for cannot be provided, and We only use these Cookies to provide You
        with those services. <br />
        <b>Functionality Cookies</b>
        <br />
        Type: Persistent Cookies <br />
        Administered by: Us <br />
        Purpose: These Cookies allow us to remember choices You make when You
        use the Website, such as remembering your login details or language
        preference. The purpose of these Cookies is to provide You with a more
        personal experience and to avoid You having to re-enter your preferences
        every time You use the Website. <br />
      </p>
      <h5>Your Choices Regarding Cookies</h5>
      <p>
        If You prefer to avoid the use of Cookies on the Website, first You must
        disable the use of Cookies in your browser and then delete the Cookies
        saved in your browser associated with this website. You may use this
        option for preventing the use of Cookies at any time.
      </p>
      <p>
        If You do not accept Our Cookies, You may experience some inconvenience
        in your use of the Website and some features may not function properly.
      </p>
      <p>
        If You'd like to delete Cookies or instruct your web browser to delete
        or refuse Cookies, please visit the help pages of your web browser.
      </p>
      <p style={{ paddingLeft: "10px" }}>
        For the Chrome web browser, please visit this page from Google:{" "}
        <a
          href="https://support.google.com/accounts/answer/32050"
          target="_blank"
        >
          {" "}
          https://support.google.com/accounts/answer/32050{" "}
        </a>{" "}
        <br />
        For the Internet Explorer web browser, please visit this page from
        Microsoft: <a href="http://support.microsoft.com/kb/278835" target="_blank"> http://support.microsoft.com/kb/278835 </a> <br />
        For the Firefox web browser, please visit this page from Mozilla:{" "}
        <a
          href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored"
          target="_blank"
        >
          {" "}
          https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored
        </a>
        <br />
        For the Safari web browser, please visit this page from Apple:{" "}
        <a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac">
          {" "}
          https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac
        </a>
        <br />
      </p>
      <p>
        For any other web browser, please visit your web browser's official web
        pages.
      </p>
      <h5>More Information about Cookies</h5>
      <p>You can learn more about cookies: What Are Cookies?.</p>
      <h5>Contact Us</h5>
      <p>
        If you have any questions about this Cookies Policy, You can contact us:
      </p>
      <ul>
        <li>
          <b>By email: </b> info@westream.app
        </li>
      </ul>
    </div>
  );
};

export default CookieData;
